
import { MainUsersComponent } from "./components/main-users.component";
import { MainUserComponent } from "./components/main-user.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'users',
        component: MainUsersComponent,
        canActivate: [AuthService]
    },
    {
        path: 'users/:id',
        component: MainUserComponent,
        canActivate: [AuthService]
    },
];

export const routableComponents = [  
  MainUsersComponent
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class UsersRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/users/users.routes.ts